import React, { Fragment } from 'react';
import styled from '@emotion/styled';

import AboutMaterialDownload from '../components/AboutMaterialDownload';
// import BreakpointDisplay from '../components/BreakpointDisplay';
import Impressum from '../components/Impressum';
import PageHeader from '../components/PageHeader';
import PageMainLayout from '../components/PageMainLayout';
// import ProjectPartners from '../components/ProjectPartners';
import ProofOfSources from '../components/ProofOfSources';
import RelatedMaterials from '../components/RelatedMaterials';
import SmartboardGallery from '../components/SmartboardGallery';
import Stacheldraht from '../components/Stacheldraht';

import SOURCES from '../data/SOURCES';
import MORE_SOURCES from '../data/MORE_SOURCES';
import { minDesktop } from '../components/styles/breakpoints';

const Footer = styled.footer`
  margin-bottom: 66px;

  margin-top: -70px;

  ${minDesktop} {
    margin-top: 10px;
  }
`;

const IndexPage = () => (
  <Fragment>
    <PageHeader />
    <PageMainLayout>
      <AboutMaterialDownload />
      <SmartboardGallery />
      <ProofOfSources sources={SOURCES} />
      <RelatedMaterials sources={MORE_SOURCES} />
    </PageMainLayout>
    <Footer>
      <Stacheldraht />
      <Impressum />
    </Footer>
  </Fragment>
);
// <BreakpointDisplay />

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js